import { components } from "src/strapi/schema";
import { getCategoriesFromReferences } from "src/components/homepage/references/getCategoriesFromReferences";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "src/components/ui/tabs";
import { useMemo } from "react";
import { ReferenceBox } from "src/components/references/ReferenceBox";
import { SectionTitle } from "src/components/homepage/section-title";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "src/components/ui/carousel";
import BlurFade from "src/components/ui/blur-fade";
import { Button } from "src/components/ui/button";
import { cn } from "src/lib/utils";
import { allReferences } from "src/components/homepage/references/sortCategories";
import { Link } from "@tanstack/react-router";

export const CarouselReferences = ({
  references,
  className,
}: {
  references: components["schemas"]["Reference"][];
  className?: string;
}) => {
  return (
    <Carousel
      opts={{
        align: "start",
        dragFree: true,
      }}
      className={cn("md:mx-16", className)}
    >
      <CarouselContent>
        {references.map((reference, index) => {
          return (
            <CarouselItem
              key={reference.id}
              className="basis-4/5 md:basis-1/2 xl:basis-1/3"
            >
              <BlurFade delay={0.1 * index}>
                <ReferenceBox
                  className={
                    "h-[300px] w-full md:h-80 lg:h-[330px] xl:h-[350px]"
                  }
                  key={reference.id}
                  reference={reference}
                />
              </BlurFade>
            </CarouselItem>
          );
        })}
      </CarouselContent>
      <CarouselPrevious />
      <CarouselNext />
    </Carousel>
  );
};

export const References = ({
  title,
  references,
}: {
  title: string;
  references: components["schemas"]["Reference"][];
}) => {
  const categories = useMemo(
    () => getCategoriesFromReferences(references),
    [references],
  );

  if (categories.length === 0) return null;

  return (
    <>
      <BlurFade inView>
        <SectionTitle title={title} />
      </BlurFade>

      {/* mobile */}
      <CarouselReferences references={references} className={"md:hidden"} />

      {/* desktop */}
      <Tabs defaultValue={categories[0].slug} className={"hidden md:block"}>
        <BlurFade inView>
          <TabsList className={"mb-2"}>
            {categories.map((category) => (
              <TabsTrigger key={category.slug} value={category.slug}>
                {category.name}
              </TabsTrigger>
            ))}
          </TabsList>
        </BlurFade>
        {categories.map((category) => (
          <TabsContent key={category.slug} value={category.slug}>
            <BlurFade inView>
              <CarouselReferences
                references={
                  category.slug === allReferences.slug
                    ? references
                    : references.filter((reference) =>
                        reference.categories?.some(
                          (referenceCategory) =>
                            referenceCategory.slug === category.slug,
                        ),
                      )
                }
              />
            </BlurFade>
          </TabsContent>
        ))}
      </Tabs>
      <BlurFade inView>
        <div className={"my-8 flex justify-center"}>
          <Button asChild variant={"outline"}>
            <Link to={"/reference"}>Zobrazit všechny</Link>
          </Button>
        </div>
      </BlurFade>
    </>
  );
};
